interface GetSubscriptionPriceBreakdownProps {
  currentPrice: number;
  currentPriceDisplayOverride: number;
  originalPrice: number;
  originalPriceDisplayOverride: number;
}

const getSubscriptionPriceBreakdown = ({
  currentPrice,
  currentPriceDisplayOverride,
  originalPrice,
  originalPriceDisplayOverride,
}: GetSubscriptionPriceBreakdownProps) => {
  const currentPriceToDisplay = currentPriceDisplayOverride || currentPrice;
  const hasDiscount = originalPrice !== currentPrice;
  const originalPriceToDisplay = originalPriceDisplayOverride || originalPrice;

  return {
    currentPriceToDisplay,
    hasDiscount,
    originalPriceToDisplay,
  };
};

export default getSubscriptionPriceBreakdown;
